webpackJsonp([23850085382367],{

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emotion = __webpack_require__(12);
	
	var _toSlug = __webpack_require__(40);
	
	var _toSlug2 = _interopRequireDefault(_toSlug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Color = function Color(_ref) {
	  var allCardsJson = _ref.data.allCardsJson,
	      _ref$pathContext = _ref.pathContext,
	      color = _ref$pathContext.color,
	      spec1 = _ref$pathContext.spec1,
	      spec2 = _ref$pathContext.spec2,
	      spec3 = _ref$pathContext.spec3;
	
	  var specsMap = allCardsJson.edges.reduce(function (acc, _ref2) {
	    var _extends2;
	
	    var node = _ref2.node;
	    return node.spec ? _extends({}, acc, (_extends2 = {}, _extends2[node.spec] = true, _extends2)) : acc;
	  }, {});
	
	  var specs = Object.keys(specsMap);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      {
	        className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("text-align:center;")
	      },
	      _react2.default.createElement(
	        "small",
	        null,
	        "[",
	        " ",
	        spec1 && spec2 && spec3 ? _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: "/deck/" + (0, _toSlug2.default)(spec1) + "/" + (0, _toSlug2.default)(spec2) + "/" + (0, _toSlug2.default)(spec3)
	          },
	          specs.join(" / ")
	        ) : _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/color/" + (0, _toSlug2.default)(color) },
	          specs.join(" / ")
	        ),
	        " ",
	        "]"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "small",
	        null,
	        "[",
	        " ",
	        spec1 && spec2 && spec3 ? _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: "/deck/" + (0, _toSlug2.default)(spec1) + "/" + (0, _toSlug2.default)(spec2) + "/" + (0, _toSlug2.default)(spec3) + "/images"
	          },
	          "All Images"
	        ) : _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/color/" + (0, _toSlug2.default)(color) + "/images" },
	          "All Images"
	        ),
	        " ",
	        "]"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("display:flex;flex-direction:column;justify-content:center;align-items:center;@media (min-width:720px){flex-direction:row;}")
	      },
	      _react2.default.createElement(
	        "h2",
	        {
	          className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("width:330px;margin:1.45rem 0;text-align:center;@media (min-width:720px){margin-right:1.0875rem;}")
	        },
	        color,
	        " Starter"
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("width:330px;")
	        },
	        _react2.default.createElement(
	          "blockquote",
	          {
	            className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("margin-bottom:0;")
	          },
	          allCardsJson.edges.map(function (_ref3) {
	            var node = _ref3.node;
	            return node.starting_zone === "deck" && _react2.default.createElement(
	              "div",
	              {
	                key: node.name,
	                className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;")
	              },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/card/" + node.slug },
	                node.name
	              ),
	              " \u2014",
	              " ",
	              _react2.default.createElement(
	                "small",
	                null,
	                node.bottom
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:1.45rem;@media (min-width:720px){}@media (min-width:1070px){flex-direction:row;}")
	      },
	      specs.map(function (spec) {
	        return _react2.default.createElement(
	          "div",
	          {
	            key: spec,
	            className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("@media (min-width:720px){display:flex;flex-direction:row;justify-content:space-around;align-items:center;}@media (min-width:1070px){flex-direction:column;margin-right:1.0875rem;}")
	          },
	          allCardsJson.edges.map(function (_ref4) {
	            var node = _ref4.node;
	            return node.spec === spec && node.type === "Hero" && _react2.default.createElement(
	              "div",
	              {
	                key: node.name,
	                className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("@media (min-width:720px){margin-right:1.0875rem;}@media (min-width:1070px){margin-right:0;}")
	              },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/card/" + node.slug },
	                _react2.default.createElement("img", {
	                  src: "//res.cloudinary.com/rgdelato/image/fetch/f_auto/http://codexcards-assets.surge.sh/images/" + node.sirlins_filename,
	                  alt: node.name,
	                  className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("@media (min-width:370px){width:330px;height:450px;}")
	                })
	              )
	            );
	          }),
	          _react2.default.createElement(
	            "div",
	            {
	              className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("width:330px;")
	            },
	            _react2.default.createElement(
	              "blockquote",
	              null,
	              allCardsJson.edges.map(function (_ref5) {
	                var node = _ref5.node;
	                return node.spec === spec && _react2.default.createElement(
	                  "div",
	                  {
	                    key: node.name,
	                    className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;")
	                  },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/card/" + node.slug },
	                    node.name
	                  ),
	                  " \u2014",
	                  " ",
	                  _react2.default.createElement(
	                    "small",
	                    null,
	                    node.bottom
	                  )
	                );
	              })
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = Color;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-color-js-2b2b2e8bf4bee7bf87ff.js